import axios from "axios";

export const fetchYears = async ({ that, link }) => {
    return await axios.get(`${that.BASE_URL}${link}`);
};